import React from 'react'

import { CFooter } from '@coreui/react-pro'

import { privacyPolicy, termsOfService } from '@constants/links'

const AppFooter = () => {
  return (
    <CFooter className="justify-content-center">
      <div>
        <a href={termsOfService} target="_blank" rel="noopener noreferrer">
          Terms of Service
        </a>{' '}
        &{' '}
        <a href={privacyPolicy} target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
